import Container from '@componentPrimitives/Container';
import Flex from '@componentPrimitives/Flex';
import Txt from '@componentPrimitives/Txt';
import Image from '@components/Image';
import { Entry } from '@lib/features/entries';
import { PageHeaderProps } from './PageHeader';
import { PageHeaderRoot } from './PageHeaderRoot';

export const PageHeaderArticle = ({ view }: PageHeaderProps<Entry<'article'>>) => {
  const { entryImage, bannerImage, postDate } = view;
  const image = bannerImage || entryImage;
  return (
    <>
      <PageHeaderRoot
        maxWidth="md"
        afterContainer={
          image && (
            <Container>
              <Image
                alt={view.title ?? ''}
                ratio="landscapeWide"
                ShimProps={{ cx: { mT: 'lg' } }}
                rounded
                {...image}
              />
            </Container>
          )
        }>
        <Flex direction="row" spacing="xs">
          <Txt variant="large">{postDate}</Txt>
        </Flex>
      </PageHeaderRoot>
    </>
  );
};
